/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@shared/services/user.service';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';

@Component({
  selector: 'app-change-profile-photo',
  templateUrl: './change-profile-photo.component.html',
  styleUrls: ['./change-profile-photo.component.scss'],
})
export class ChangeProfilePhotoComponent  implements OnInit {
  public pictures: any = [];
  public me: any;
  public hasPhotoAtIndex0: boolean = false;
  public photoAtIndex0: string | null = null;
  constructor(private modalCtrl: ModalController,
    private router: Router,
    private translate: TranslateService,
    public userService: UserService,
    private navParams: NavParams,
  ) { }

  ngOnInit() {
    this.me = this.navParams.get('me');
    this.loadMyImages();
  }

  goBack(){
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  editPhoto(){
    this.modalCtrl.dismiss('editPhoto');
  }

  async redoValidation(){
    Preferences.remove({key:'MODAL_SHOWN_COUNT'}).then((_val) => {
      console.log('LOCAL_PROMOTION removed from DB');
    });
    const theObs = this.userService.redoValidation(this.me);

    theObs.subscribe(async data => {
      console.log('redoValidation subscribe entered');
      if (data != '{not ok}'){
        console.log('data = ' + JSON.stringify(data));
        data = JSON.parse(data);
        console.log("data parsed: ", data);
        delete this.me['hasValidSelfie'];
        delete this.me['selfieid'];
        delete this.me['hasValidPoseSelfie'];
        delete this.me['poseselfieid'];
        delete this.me['userValidated'];
        return;
      } else {
        console.log('data = ' + JSON.stringify(data));
        return; 
      }
    },
      async err => {
        console.log('Error: ' + err);
        return; 
      })

      await this.dismissAllModals();
      this.router.navigate(['/instructions-check-profile'], { queryParams: { originValidation: '/tabs/my-profile-display' } });
  }

  async dismissAllModals() {
    const modals = document.querySelectorAll('ion-modal');
    for (const modal of Array.from(modals)) {
      await (modal as HTMLIonModalElement).dismiss();
    }
  }
  

  private loadMyImages() {

    let picnum : number;
    let picCount : number = 0;
    this.pictures = [];
    
    // Verificar se há foto no index 0 (picture0)
    if (this.me['picture0'] != null) {
      this.hasPhotoAtIndex0 = true;
      this.photoAtIndex0 = this.userService.getImageURL(this.me['picture0'].$oid);
    } else {
      this.hasPhotoAtIndex0 = false;
      this.photoAtIndex0 = null;
    }
    
    for(picnum=0; picnum<9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (this.me[aPic] != null) {
        const aPicIndex = picCount;
        picCount++;
        console.log('has picture' + picnum);
        console.log('this.me[aPic].$oid: ' + this.me[aPic].$oid);
        
        const aPicture = this.userService.getImageURL(this.me[aPic].$oid); // this.soulService.getBaseURL() + '/soul/image/' + this.me[aPic].$oid;

        this.pictures[aPicIndex] = aPicture;

        // download in background

        const _aFile = aPic + '.jpg';

        continue;

      }
    }

  }

}
